/**
 * "book a meeting" on the mission page: someone signed in goes to their desktop, anyone else gets the booking calendar.
 * ONE rule, run by today's page (src/pages/Mission.tsx, which opens its own calendar dialog) and its rebuild in the new
 * design (which opens the shell's), so the two can never disagree about where the button goes (design record §7b,
 * rule 1).
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function useBookOrDesktop(openBooking: () => void): () => void {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  return useCallback(() => {
    if (isAuthenticated) navigate('/desktop');
    else openBooking();
  }, [isAuthenticated, navigate, openBooking]);
}
